export default function() {
	$(function() {
		const $toTopBtn = $('.js-to-top');

		if(innerWidth > 768) {
			$toTopBtn.hide();

			$(window).on('load scroll resize orientationchange',function () {
				const scrollPos = $(window).height() + $(window).scrollTop();
				const endOffset = $('#footer').offset().top;
				const toTopBtnHeight = $toTopBtn.height();

				if($(this).scrollTop() < 100) {
					$toTopBtn.fadeOut();
				}else if($(this).scrollTop() > 100) {
					$toTopBtn.fadeIn();
				}

				if(scrollPos >= endOffset) {
					$toTopBtn.css({
						position: "absolute",
						top: endOffset - (toTopBtnHeight + 170),
					});
				} else {
					$toTopBtn.css({
						position: "fixed",
						top: "initial",
						bottom: 40
					});
				}
			});
		}
	})
}
